import Api from "@/helpers/api.js";

export default {
	addStatus({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.post("/status", item)
				.then((response) => {
					commit("ADD_STATUS", Object.assign(item, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchDataListItems({commit, dispatch}) {
		return new Promise((resolve, reject) => {
			Api.get("/status")
				.then((res) => {
					commit("SET_STATUS", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	fetchResourceData({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/resource")
				.then((res) => {
					commit("SET_RESOURCES", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updateItem({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.put(`/status/${item.id}`, item)
				.then((response) => {
					commit("UPDATE_STATUS", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/status/${itemId}`)
				.then((response) => {
					commit("REMOVE_STATUS", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
